module.exports = "/fonts/fa-solid-900.woff?1824ad4c98679821970e3e7e47a1aa02";